module.exports = __webpack_public_path__ + "static/media/51_A.682d88c2.png";